export default {
  data: () => ({
    qrCodeMarkup: '',
    qrDataURL: ''
  }),

  methods: {
    generateQR(options = {}) {
      let url = `https://mytype.d2l.com`+this.$route.fullPath.replace(`/leaderboard`, '');
    
      if (this.isSingleEvent()) {
        url += `?utm_source=leaderboard-qrcode`;
      }
      //console.log(url);

      // generate QR code
      // const qr = new QRCode( this.$refs.qrcode, {
      //   text: url,
      //   colorLight: '#ffffff',
      //   colorDark: '#000000'
      // } );

      // SVG QRCode Library
      const qr = new QRCode({
        ...{
          content: url,
          padding: 4,
          width: 256,
          height: 256,
          color: "#000000",
          background: "#ffffff",
          ecl: "M"
        },
        ...options
      });

      const svgMarkup = qr.svg();

      this.qrCodeMarkup = svgMarkup;
      this.qrDataURL = 'data:image/svg+xml;base64,' + btoa(qr.svg());

      // const qr = new QRious({
      //   element: this.$refs.qrcode,
      //   value: url,
      //   padding: 25,
      //   size: 500
      // });

      // this.$refs.qrcode.appendChild(qr.image);
      // this.$refs.qrcode.querySelector( 'img' ).setAttribute( 'alt', 'Scan this QR code to be taken to the quiz' );

      // this.qrDataURL = qr.toDataURL(); //png by default
      
      // set the alt attribute on the img
      // this.$refs.qrcode.querySelector( 'img' ).setAttribute( 'alt', 'Scan this QR code to be taken to the quiz' );
    }
  }
}